import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Medicare from "../images/medical provider.png";
import Police from "../images/police.png";
import GroceryStore from "../images/grocery store employee.png";
import DeliveryDriver from "../images/delivery person.png";
import EachPerson from "../images/eachPerson.png";
import Worker from "../images/worker.png";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles((theme) => ({
  cardMedia: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  cardContent: {
    textAlign: 'center'
  },
  container: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  }
}));

const heros = [
  {
    title: 'Healthcare Professionals',
    image: Medicare,
  },
  {
    title: 'Police Officers',
    image: Police,
  },
  {
    title: 'Grocery Store Employees',
    image: GroceryStore,
  },
  {
    title: 'Delivery Drivers',
    image: DeliveryDriver,
  },
  {
    title: 'Each of You',
    image: EachPerson,
  },
  {
    title: 'Essential Workers',
    image: Worker,
  }

];

export default function Dashboard(props) {
  const classes = useStyles();
  const { onSelect } = props;

  const selectOccupation = (hero) => {
    onSelect(hero);
  };

  return (
    <Container maxWidth="md">
      <Grid container spacing={4} className={classes.container}>
        {heros.map((hero) => (
          <Grid item key={hero.title} xs={12} sm={6} md={4}>
            <Card className={classes.card}>
              <CardActionArea onClick={() => selectOccupation(hero)}>
                <img src={hero.image} width="100" height="100" className={classes.cardMedia} alt="Hero"/>
                <CardContent className={classes.cardContent}>
                  <Typography gutterBottom variant="subtitle1">
                    {hero.title}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
